import { getOwner } from '@ember/application';
import Service from '@ember/service';
import { captureException, captureMessage, withScope } from '@sentry/ember';

// A service that wraps the Sentry Javascript SDK.
// Sentry must be configured and initialized in the consuming app (eg, Dashboard).
// For more information about capturing custom errors and messages,
// see the docs: https://docs.sentry.io/error-reporting/capturing/?platform=node
export default class Sentry extends Service {
  captureException(...args) {
    if (this.shouldLog) {
      captureException(...args);
    } else {
      // eslint-disable-next-line no-console
      console.error('[SENTRY]', args[0]);
    }
  }
  captureMessage(...args) {
    if (this.shouldLog) {
      captureMessage(...args);
    } else {
      // eslint-disable-next-line no-console
      console.error('[SENTRY]', args[0]);
    }
  }
  withScope(callback) {
    if (this.shouldLog) {
      withScope(callback);
    } else {
      // Create a mock scope for local development that logs to console
      const mockScope = {
        setExtra: (key, value) => {
          // eslint-disable-next-line no-console
          console.log(`[SENTRY] setExtra: ${key}`, value);
        },
        setTag: (key, value) => {
          // eslint-disable-next-line no-console
          console.log(`[SENTRY] setTag: ${key}`, value);
        },
        setLevel: level => {
          // eslint-disable-next-line no-console
          console.log(`[SENTRY] setLevel: ${level}`);
        }
      };
      callback(mockScope);
    }
  }
  get shouldLog() {
    return getOwner(this).resolveRegistration('config:environment').environment === 'production';
  }
}